<script>
import Statistics from './Statistics'
import AbnormalStatistics from '@/orm/models/AbnormalStatistics'
import TablePopup from './TablePopup'
export default {
  name: 'AbnormalStatistics',
  extends: Statistics,
  components: {
    TablePopup
  },
  data () {
    return {
      isAbnormalStatistics: true,
      mode: 'date',
      date: this.getRangeDate(30),
      range: true,
      detailPopup: {
        show: false,
        channel: '',
        data: []
      },
      detailPagination: {
        rowsPerPage: 10,
        sortBy: 'total_expense',
        descending: true
      }
    }
  },
  computed: {
    detailHeaders () {
      const headers = [...this.headers]
      headers.splice(0, 1, {
        sortable: false,
        text: this.$t('organization'),
        value: 'clientName',
        width: '150px'
      },
      {
        sortable: false,
        text: this.$t('department'),
        value: 'department',
        width: '120px'
      },
      {
        sortable: false,
        text: this.$t('manager'),
        value: 'manager',
        width: '120px'
      })
      return headers
    },
    curDailyStatisticsData () {
      const [startTime, endTime] = this.date.map(item => new Date(item).getTime())
      const result = Object.entries(this.allStatisticsData).reduce((obj, [date, data]) => {
        const targetTime = new Date(date).getTime()
        const isBetween = targetTime >= startTime && targetTime <= endTime
        if (!isBetween) return obj
        data.forEach(row => {
          const { channel, statistics, clientKey, clientName } = row
          const targetObj = obj[channel]
          if (!targetObj) {
            obj[channel] = {
              ...statistics,
              channel,
              details: [{ ...statistics, clientKey, clientName }]
            }
          } else {
            Object.entries(statistics).forEach(([key, val]) => {
              obj[channel][key] += val
            })
            obj[channel].details.push({ ...statistics, clientKey, clientName })
          }
        })
        return obj
      }, {})
      return Object.values(result).filter(item => item.invCount)
    },
    allStatisticsData () {
      const data = this.$store.getters.abnormalStatistics || {}
      return data
    },
    leftChartOption () {
      return this.getCommonOptions({
        title: 'abnormalStatistics.diffAmount',
        seriesName: 'abnormalStatistics.diffAmount',
        data: this.sortLeftData
      })
    },
    rightChartOption () {
      return this.getCommonOptions({
        title: 'abnormalStatistics.diffZone',
        seriesName: 'abnormalStatistics.diffZone',
        data: this.sortRightData
      })
    },
    sortLeftData () {
      const allData = this.sortData(this.targetData, 'diffAmount')
      return this.getRankAndOtherData(allData, 'diffAmount')
    },
    sortRightData () {
      const zones = AbnormalStatistics.zoneItems
      const zoneTotalObj = this.targetData.reduce(
        (objTotal, item) => {
          zones.forEach(zone => {
            const num = item[zone] || 0
            const objNum = objTotal[zone] || 0
            objTotal[zone] = objNum + num
            objTotal.total += num
          })
          return objTotal
        },
        {
          total: 0
        }
      )
      return zones.map(item => {
        return {
          value: zoneTotalObj[item] || 0,
          name: item
        }
      })
    },
    headers () {
      return AbnormalStatistics.getHeader.call(this)
    }
  },
  methods: {
    showDetails (data) {
      const { details, channel } = data
      this.detailPopup = {
        data: details.reduce((arr, item) => {
          const { clientKey, clientName, ...rest } = item
          const target = arr.find(row => row.clientKey === clientKey)
          if (target) {
            Object.entries(rest).forEach(([key, val]) => {
              target[key] += val
            })
          } else {
            const systemBalance = this.systemBalanceMap[item.clientKey]
            const { accountManager = '', department = '' } = systemBalance || {}
            arr.push({ ...item, manager: accountManager, department })
          }
          return arr
        }, []),
        channel,
        show: true
      }
    },
    getAllRangeDate () {
      const date = Object.keys(this.$store.getters.abnormalStatistics)
        .map(date => new Date(date))
        .sort((a, b) => {
          return a.getTime() - b.getTime()
        })
      if (date.length === 1) date.push(date[0])
      return [date[0], date.at(-1)]
    }
  }
}
</script>

<style scoped>
  .chart {
    height: 300px;
  }

  .table >>> .v-datatable {
    table-layout: fixed;
  }
</style>



// WEBPACK FOOTER //
// src/components/AbnormalStatistics.vue